import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { OPTIONS_TOAST } from "../../shared/consts";
import { getShipmentStatusList } from "../../services/shipmentStatus.service";

const initialState = {
  isLoading: false,
  list: [],
  currentPageList: 1,
  totalPageList: 1,
  sizePageList: 1,
  errorMsg: null,
};

/** SLICES */
export const shipmentStatusSlice = createSlice({
  name: "shipmentStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getShipmentStatusList.pending, (state, action) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(getShipmentStatusList.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload.data;
        return {
          ...state,
          isLoading: false,
          list: data,
          errorMsg: null,
        };
      }
      return state;
    });
    builder.addCase(getShipmentStatusList.rejected, (state, action) => {
      toast.dismiss();
      toast.error(`${action.payload}`, OPTIONS_TOAST);
      return {
        ...state,
        isLoading: false,
        errorMsg: action.payload,
      };
    });
  },
});

// export const { } = roleSlice.actions;
export default shipmentStatusSlice.reducer;
